export function formatCurrency({ amount = 0, currency, locale, decimalCount } = {}) {
    const amountNumber = Number(amount);
    if (currency) {
        const fractionDigits = decimalCount ?? getDisplayPrecision(amountNumber);
        return Intl.NumberFormat(locale, {
            style: 'currency',
            unitDisplay: 'narrow',
            currency,
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
        }).format(amountNumber);
    }
    if (decimalCount) {
        return amountNumber.toFixed(decimalCount);
    }
    return String(amount);
}
function getDisplayPrecision(amount) {
    return Number.isInteger(amount) ? 0 : 2;
}
export function formatCurrencyParts({ amount = 0, currency, locale, decimalCount } = {}) {
    const amountNumber = Number(amount);
    if (!currency) {
        return {
            value: formatCurrency({
                amount,
                locale,
                decimalCount
            }),
            isCurrencyPrefixed: false
        };
    }
    const fractionDigits = decimalCount ?? getDisplayPrecision(amountNumber);
    const parts = Intl.NumberFormat(locale, {
        style: 'currency',
        unitDisplay: 'narrow',
        currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits
    }).formatToParts(amountNumber);
    const currencyIndex = parts.findIndex((part)=>part.type === 'currency');
    const firstValueIndex = parts.findIndex((part)=>part.type !== 'currency' && part.type !== 'literal');
    return {
        value: parts.filter((part)=>part.type !== 'currency' && part.type !== 'literal').map((part)=>part.value).join(''),
        isCurrencyPrefixed: currencyIndex !== -1 && firstValueIndex !== -1 && currencyIndex < firstValueIndex
    };
}

//# sourceMappingURL=format-currency.js.map